export const moduleSlug = "QUEUES";

export default { moduleSlug };